module.exports = __webpack_public_path__ + "static/media/train.9a1234ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/project/train.jpg
// module id = 476
// module chunks = 0